/** Fertility chapter interactive demo (product tour / "Demo" nav) */
export const FERTILITY_DEMO_HOME = '/demo/fertility/home';

/** Max viewport width (px) at which the full demo is hidden behind the desktop-only modal */
export const DEMO_VIEWPORT_MAX_WIDTH_PX = 900;
